import { render, staticRenderFns } from "./SecurityCheckbox.vue?vue&type=template&id=be4ec9ba&scoped=true&"
import script from "./SecurityCheckbox.vue?vue&type=script&lang=js&"
export * from "./SecurityCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SecurityCheckbox.vue?vue&type=style&index=0&id=be4ec9ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ec9ba",
  null
  
)

export default component.exports